import { ChangeEvent, Dispatch, SetStateAction, useCallback, useState } from 'react'

export type UseStoreDeliveryBreadChoices = {
  addChoice: () => void
  clearChoice: () => void
  choices: string[]
  deleteChoice: (index: number) => void
  handleChoice: (event: ChangeEvent<HTMLInputElement>, index: number) => void
  initChoice: () => void
  setChoices: Dispatch<SetStateAction<string[]>>
}

const useStoreDeliveryBreadChoices = (): UseStoreDeliveryBreadChoices => {
  const [choices, setChoices] = useState<string[]>([])

  const addChoice = useCallback(() => {
    setChoices((prevState) => [...prevState, ''])
  }, [setChoices])

  const clearChoice = useCallback(() => setChoices([]), [setChoices])

  const deleteChoice = useCallback(
    (index: number) => {
      setChoices((prevState) => {
        const nextState = prevState.filter((_, i) => i !== index)
        return [...nextState]
      })
    },
    [setChoices]
  )

  const handleChoice = useCallback(
    (event: ChangeEvent<HTMLInputElement>, index: number) => {
      setChoices((prevState) => {
        const nextState = prevState
        nextState[index] = event.target.value
        return [...nextState]
      })
    },
    [setChoices]
  )

  const initChoice = useCallback(() => setChoices(['']), [setChoices])

  return {
    addChoice,
    clearChoice,
    choices,
    deleteChoice,
    handleChoice,
    initChoice,
    setChoices,
  }
}

export default useStoreDeliveryBreadChoices
